import { Link } from "react-router-dom";
import { downloadFileIcon } from "../../../assets/icons";
import styles from "./documentlink.module.css";

interface Props {
  text: string;
  link: string;
  isPreview?: boolean;
  fileName: string;
}

export default function DocumentButton({ text, link, isPreview, fileName }: Props) {
  if (isPreview) {
    return (
      <Link to={link} className={`${styles.link} no-click`}>
        <p>{text}</p>
        {downloadFileIcon}
      </Link>
    )
  } else {
    return (
      <a href={link} className={styles.link} download={fileName} >
        <p>{text}</p>
        {downloadFileIcon}
      </a>
    )
  }
}

